"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <label class="swiftref-radio-button-label">
           <input type="radio" class="swiftref-radio-button"> 
    </label>
`;
